import Home from './components/Home.vue'
//import App from './App.vue'
//import LogIn from './components/LogIn.vue'
import SignUp from './components/SignUp.vue'
import Acquirer from './components/Acquirer.vue'
import User from './components/User.vue'
import Country from './components/Country.vue'
import NetworkParams from './components/NetworkParams.vue'
import Organization from './components/Organization.vue'
import MerchantActivity from './components/MerchantActivity.vue'
import Currency from './components/Currency.vue'
import Operations from './components/Operations.vue'
import Aid from './components/Aid.vue'
import Capk from './components/Capk.vue'
import Merchant from './components/Merchant.vue'
import Devices from './components/Devices.vue'
import Devices2 from './components/Devices2.vue'
import addDevice from './components/addDevice.vue'
import updateDevice from './components/updateDevice.vue'
import DeviceDetails from './components/DeviceDetails.vue'
import AcqDevices from './components/AcqDevices.vue'
import OrgDevices from './components/OrgDevices.vue'
import Staff from './components/Staff.vue'
import Discount from './components/Discount.vue'
import Surcharge from './components/Surcharge.vue'
import BlackList from './components/BlackList.vue'
import Receipt from './components/Receipt.vue'
import Issuer from './components/Issuer.vue'
import CardRange from './components/CardRange.vue'
import License from './components/License.vue'
import Terminal from './components/Terminal.vue'
import Model from './components/Model.vue'
import Supplier from './components/Supplier.vue'
import LicenseApp from './components/LicenseApp.vue'
import AppToApp from './components/AppToApp.vue'
import DownloadHistory from './components/DownloadHistory.vue'
import FeatureFlag from './components/FeatureFlag.vue'

import { createRouter, createWebHistory } from 'vue-router'
//import keycloak from './service/keycloak'


const routes = [
        
     {
         name: "Home",
         component: Home,
         path: "/",
         meta: { requiresAuth: true }
     },
    
    {
        name: "SignUp",
        component: SignUp,
        path: "/sign-up"
    },
    {
        name: "Acquirer",
        component: Acquirer,
        path: "/acquirer",
        meta: { requiresAuth: true }
    },
    {
        name: "User",
        component: User,
        path: "/users",
        meta: { requiresAuth: true }
    },
    {
        name: "Country",
        component: Country,
        path: "/countries",
        meta: { requiresAuth: true }
    },
    {
        name: "NetworkParams",
        component: NetworkParams,
        path: "/network_params",
        meta: { requiresAuth: true }
    },
    {
        name: "Organization",
        component: Organization,
        path: "/organization",
        meta: { requiresAuth: true }
        
    },
    {
        name: "MerchantActivity",
        component: MerchantActivity,
        path: "/merchant-activity",
        meta: { requiresAuth: true }
    },
    {
        name: "Currency",
        component: Currency,
        path: "/currency",
        meta: { requiresAuth: true }
    },
    {
        name: "Operations",
        component: Operations,
        path: "/operation",
        meta: { requiresAuth: true }
    },
    
    {
        name: "Aid",
        component: Aid,
        path: "/aid",
        meta: { requiresAuth: true }
    },
    {
        name: "Capk",
        component: Capk,
        path: "/capk",
        meta: { requiresAuth: true }
    },
    {
        name: "Merchant",
        component: Merchant,
        path: "/merchant",
        meta: { requiresAuth: true }
    },
    {
        name: "Devices",
        component: Devices,
        path: "/devices",
        meta: { requiresAuth: true }
    },
    {
        name: "addDevice",
        component: addDevice,
        path: "/add-device",
        meta: { requiresAuth: true }
    },
    {
        name: "updateDevice",
        component: updateDevice,
        path: "/update-device/:id",
        meta: { requiresAuth: true }
    },
    {
        name: "DeviceDetails",
        component: DeviceDetails,
        path: "/device-details",
        meta: { requiresAuth: true },
        children: [

            /* {
                name: "Devices2",
                component: Devices2,
                path: "/devices/list"
            }, */
            /* {
                name: "Devices2",
                component: Devices2,
                path: "/devices/list/:id",
                meta: {
                    watchParam: 'id'
                }
            }, */

            {
                name: "Devices2",   /* to be remove */
                component: Devices2,
                path: "/devices-list/:id",
                meta: {
                    requiresAuth: true,
                    watchParam: 'id'
                }
            },

            {
                name: "AcqDevices",
                component: AcqDevices,
                path: "/device-acquirer/:id",
                meta: {
                    requiresAuth: true,
                    watchParam: 'id'
                  }
            },
            {
                name: "OrgDevices",
                component: OrgDevices,
                path: "/device-org/:id",
                meta: {
                    requiresAuth: true,
                    watchParam: 'id'
                  }
            },
            
        ]
    },    
    
    {
        name: "staff",
        component: Staff,
        path: "/staff",
        meta: { requiresAuth: true }
    },
    
    {
        name: "Discount",
        component: Discount,
        path: "/discount",
        meta: { requiresAuth: true }
    },
    {
        name: "Surcharge",
        component: Surcharge,
        path: "/surcharge",
        meta: { requiresAuth: true }
    },
    {
        name: "BlackList",
        component: BlackList,
        path: "/blacklist",
        meta: { requiresAuth: true }
    },
    {
        name: "Receipt",
        component: Receipt,
        path: "/receipt",
        meta: { requiresAuth: true }
    },
    {
        name: "Issuer",
        component: Issuer,
        path: "/issuer",
        meta: { requiresAuth: true }
    },
    {
        name: "CardRange",
        component: CardRange,
        path: "/cardRange",
        meta: { requiresAuth: true }
    },
    {
        name: "License",
        component: License,
        path: "/license",
        meta: { requiresAuth: true }
    },
    {
        name: "Terminal",
        component: Terminal,
        path: "/terminal",
        meta: { requiresAuth: true }
    },
    {
        name: "Model",
        component: Model,
        path: "/model",
        meta: { requiresAuth: true }
    },
    {
        name: "Supplier",
        component: Supplier,
        path: "/supplier",
        meta: { requiresAuth: true }
    } ,
    {
        name: "LicenseApp",
        component: LicenseApp,
        path: "/licenseApp",
        meta: { requiresAuth: true }
    },
    {
        name: "AppToApp",
        component: AppToApp,
        path: "/appToApp",
        meta: { requiresAuth: true }
    }, 
    {
        name: "DownloadHistory",
        component: DownloadHistory,
        path: "/downloadistory",
        meta: { requiresAuth: true }
    }, 
    {
        name: "FeatureFlag",
        component: FeatureFlag,
        path: "/featureFlag",
        meta: { requiresAuth: true }
    },
];




const router = createRouter({
    history: createWebHistory(),
    routes,
});


/* router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!keycloak.authenticated) {
        keycloak.login();
      } else {
        next();
      }
    } else {
      next();
    }
  }); */


export default router;